import actionTypes from "utils/redux/actions/actionTypes";
import { chatTrace } from "utils/chatTrace";

function buildIsAdminAuditRows(chatItems = []) {
    if (!Array.isArray(chatItems)) {
        return [];
    }

    return chatItems.map((item, index) => ({
        index,
        customerNumber: item?.customerNumber || item?.sourcePhone || item?.source || item?.destination || "",
        customerName: item?.customerName || "",
        isAdminTransaction: item?.isAdminTransaction,
        apiIsAdminTransaction: item?.__apiIsAdminTransaction,
        isOpenTransaction: item?.isOpenTransaction,
        isOpenAdmin: item?.isOpenAdmin,
        apiIsOpenTransaction: item?.__apiIsOpenTransaction,
        apiIsOpenAdmin: item?.__apiIsOpenAdmin,
        activityId: item?.activityId,
        apiActivityId: item?.__apiActivityId,
        apiAuditRequestId: item?.__apiAuditRequestId,
        apiAuditPage: item?.__apiAuditPage,
        apiAuditIndex: item?.__apiAuditIndex
    }));
}

function collectIsAdminBaselineMismatches(auditRows = []) {
    return auditRows.filter((row) => {
        return row.apiIsAdminTransaction !== undefined && row.apiIsAdminTransaction !== row.isAdminTransaction;
    });
}

const initialState = {
    chatList: [],
    isLoading: false,
    isLoadingMore: false,
    hasMore: true,
    currentPage: 0,
    hasError: false,
    errorMessage: "",
    filterOptions: [],
    filterOptionsLoading: false,
    filterOptionsError: false,
    filterOptionsErrorMessage: "",
    query: {
        searchText: "",
        activityId: null
    },
};
export function chatReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.SELECT_CHAT_LIST_QUERY_CHANGED:
            return {
                ...state,
                query: action.query || initialState.query
            };

        case actionTypes.SELECT_CHAT_LIST_SUCCESS:
            // Boş payload gelirse mevcut listeyi koru (race condition koruması)
            if (!Array.isArray(action.payload)) {
                return state;
            }

            const selectSuccessAuditRows = buildIsAdminAuditRows(action.payload);
            const selectSuccessMismatches = collectIsAdminBaselineMismatches(selectSuccessAuditRows);

            chatTrace("reducer.chatList.apiSnapshot.applied", {
                requestId: action.adminAuditRequestId,
                page: action.adminAuditPage,
                itemCount: selectSuccessAuditRows.length,
                mismatchCount: selectSuccessMismatches.length,
                items: selectSuccessAuditRows,
                mismatches: selectSuccessMismatches
            }, "warn");

            return {
                ...state,
                chatList: action.payload,
                currentPage: 1,
                hasMore: action.hasMore !== undefined ? action.hasMore : true,
                isLoadingMore: false,
                query: action.query || state.query
            };

        case actionTypes.SELECT_CHAT_LIST_APPEND:
            // Append için de dizi kontrolü
            if (!Array.isArray(action.payload)) {
                return {
                    ...state,
                    isLoadingMore: false
                };
            }

            const appendAuditRows = buildIsAdminAuditRows(action.payload);
            const appendMismatches = collectIsAdminBaselineMismatches(appendAuditRows);

            chatTrace("reducer.chatList.apiSnapshot.appended", {
                requestId: action.adminAuditRequestId,
                page: action.adminAuditPage,
                appendedCount: appendAuditRows.length,
                mismatchCount: appendMismatches.length,
                appendedItems: appendAuditRows,
                mismatches: appendMismatches
            }, "warn");

            return {
                ...state,
                chatList: [...state.chatList, ...action.payload],
                currentPage: action.page,
                hasMore: action.hasMore,
                isLoadingMore: false,
                query: action.query || state.query
            };

        case actionTypes.SELECT_CHAT_LIST_HAS_MORE:
            return {
                ...state,
                isLoadingMore: action.isLoadingMore
            };

        case actionTypes.SELECT_CHAT_LIST_LOADING:
            return {
                ...state,
                isLoading: action.isLoading
            };

        case actionTypes.SELECT_CHAT_LIST_ERROR:
            return {
                ...state,
                hasError: action.hasError,
                errorMessage: action.errorMessage
            };

        case actionTypes.SELECT_CHAT_DETAIL_LIST_SUCCESS:
            if (!action.customerNumber) {
                return state;
            }

            var detailSyncList = JSON.parse(JSON.stringify(state.chatList));
            var detailSyncIndex = detailSyncList.findIndex(w => w.customerNumber == action.customerNumber);

            if (detailSyncIndex != -1) {
                if (action.activityId !== undefined) {
                    detailSyncList[detailSyncIndex].activityId = action.activityId;
                }
                if (action.activityName !== undefined) {
                    detailSyncList[detailSyncIndex].activityName = action.activityName;
                }
                if (action.messageType !== undefined && detailSyncList[detailSyncIndex].messageType === undefined) {
                    detailSyncList[detailSyncIndex].messageType = action.messageType;
                }
                if (action.isAdminTransaction !== undefined) {
                    detailSyncList[detailSyncIndex].isAdminTransaction = action.isAdminTransaction;
                }
                if (action.isOpenTransaction !== undefined) {
                    detailSyncList[detailSyncIndex].isOpenTransaction = action.isOpenTransaction;
                }
                if (action.isOpenAdmin !== undefined) {
                    detailSyncList[detailSyncIndex].isOpenAdmin = action.isOpenAdmin;
                }

            }

            return {
                ...state,
                chatList: detailSyncList
            };

        case actionTypes.CHAT_MASTER_UPDATE_PREV_TEXT:

            var newList = JSON.parse(JSON.stringify(state.chatList));
            var index = newList.findIndex(w => w.customerNumber == action.customerNumber);

            chatTrace("reducer.chatMasterUpdate.received", {
                traceId: action.traceId,
                customerNumber: action.customerNumber,
                activeNumber: action.activeNumber,
                foundInList: index !== -1,
                chatListLength: newList.length,
                moveToTop: !!action.moveToTop
            });

            if (index != -1) {
                newList[index].lastWrittenMessage = action.newText;
                // Son mesaj tarih ve saatini güncelle
                if (action.messageDate) {
                    newList[index].lastMessageDate = action.messageDate;
                }
                if (action.messageTime) {
                    newList[index].lastMessageTime = action.messageTime;
                }
                // Eğer aktif sohbet değilse unread artır
                if (action.activeNumber !== action.customerNumber) {
                    newList[index].unreadMessageCount = newList[index].unreadMessageCount + 1;
                }
                
                // Eğer moveToTop true ise, öğeyi listenin başına taşı
                if (action.moveToTop) {
                    const item = newList[index];
                    newList.splice(index, 1);
                    newList.unshift(item);
                }

                chatTrace("reducer.chatMasterUpdate.applied", {
                    traceId: action.traceId,
                    customerNumber: action.customerNumber,
                    unreadMessageCount: newList[0]?.customerNumber == action.customerNumber
                        ? newList[0].unreadMessageCount
                        : newList[index]?.unreadMessageCount
                });
            } else {
                chatTrace("reducer.chatMasterUpdate.missed", {
                    traceId: action.traceId,
                    customerNumber: action.customerNumber,
                    reason: "conversation_not_in_sidebar"
                }, "warn");
            }

            return {
                ...state,
                chatList: newList
            };
        case actionTypes.RESET_UNREAD_COUNT:

            var newList = JSON.parse(JSON.stringify(state.chatList));
            var index = newList.findIndex(w => w.customerNumber == action.customerNumber);

            if (index != -1) {
                newList[index].unreadMessageCount = 0;
            }

            return {
                ...state,
                chatList: newList
            };
        case actionTypes.ON_CHAT_LISTENER:
            var data = action.payload;
            var destination = data.customerNumber || data.destination || data.sourcePhone || data.source;

            if (!destination) {
                chatTrace("reducer.onChatListener.ignored", {
                    traceId: data?.traceId,
                    reason: "missing_destination"
                }, "warn");
                return state;
            }

            var newList = JSON.parse(JSON.stringify(state.chatList));
            var numberIndex = newList.findIndex(w => w.customerNumber == destination);

            chatTrace("reducer.onChatListener.received", {
                traceId: data?.traceId,
                customerNumber: destination,
                foundInList: numberIndex !== -1,
                chatListLength: newList.length,
                sendType: data.sendType,
                isOpenTransaction: data.isOpenTransaction,
                isOpenAdmin: data.isOpenAdmin,
                isAdminTransaction: data.isAdminTransaction,
                activityId: data.activityId
            });

            if (numberIndex == -1) {
                var estimatedIsOpenAdmin = data.isOpenAdmin !== undefined ? data.isOpenAdmin : data.sendType === 2;
                var estimatedIsOpenTransaction = data.isOpenTransaction !== undefined ? data.isOpenTransaction : true;
                var estimatedIsAdminTransaction = data.isAdminTransaction !== undefined ? data.isAdminTransaction : estimatedIsOpenAdmin;

                var chatObj = {
                    customerId: data.customerId || -1,
                    customerImage: data.customerImage || "",
                    customerName: data.customerName || data.sourcePhone || destination,
                    firmId: data.firmId || -1,
                    lastMessageDate: data.messageDate || "",
                    lastMessageTime: data.messageTime || "",
                    lastWrittenMessage: action.payload.lastWrittenMessage,
                    unreadMessageCount: 1,
                    customerNumber: destination,
                    productName: action.payload.productName || "",
                    isOpenTransaction: estimatedIsOpenTransaction,
                    isOpenAdmin: estimatedIsOpenAdmin,
                    isAdminTransaction: estimatedIsAdminTransaction,
                    __apiIsAdminTransaction: undefined,
                    __apiIsOpenTransaction: undefined,
                    __apiIsOpenAdmin: undefined,
                    __apiActivityId: undefined,
                    __apiAuditRequestId: undefined,
                    __apiAuditPage: undefined,
                    __apiAuditIndex: undefined,
                    activityId: data.activityId ?? 0,
                    activityName: data.activityName ?? ""

                }
                newList.unshift(chatObj);

                chatTrace("reducer.onChatListener.inserted", {
                    traceId: data?.traceId,
                    customerNumber: destination,
                    isOpenTransaction: chatObj.isOpenTransaction,
                    isOpenAdmin: chatObj.isOpenAdmin,
                    isAdminTransaction: chatObj.isAdminTransaction,
                    activityId: chatObj.activityId,
                    activityName: chatObj.activityName
                });

                return {
                    ...state,
                    chatList: newList
                };

            } else {
                const previousApiIsAdminTransaction = newList[numberIndex].__apiIsAdminTransaction;
                const previousIsAdminTransaction = newList[numberIndex].isAdminTransaction;

                // Mevcut sohbet varsa son mesaj tarih ve saatini güncelle
                newList[numberIndex].lastMessageDate = data.messageDate || newList[numberIndex].lastMessageDate;
                newList[numberIndex].lastMessageTime = data.messageTime || newList[numberIndex].lastMessageTime;
                newList[numberIndex].lastWrittenMessage = action.payload.lastWrittenMessage;

                if (data.isOpenTransaction !== undefined) {
                    newList[numberIndex].isOpenTransaction = data.isOpenTransaction;
                }
                if (data.isOpenAdmin !== undefined) {
                    newList[numberIndex].isOpenAdmin = data.isOpenAdmin;
                }
                if (data.isAdminTransaction !== undefined) {
                    newList[numberIndex].isAdminTransaction = data.isAdminTransaction;
                }
                if (data.activityId !== undefined) {
                    newList[numberIndex].activityId = data.activityId;
                }
                if (data.activityName !== undefined) {
                    newList[numberIndex].activityName = data.activityName;
                }

                if (previousApiIsAdminTransaction !== undefined && newList[numberIndex].isAdminTransaction !== previousApiIsAdminTransaction) {
                    chatTrace("reducer.onChatListener.isAdminTransaction.baselineDiverged", {
                        traceId: data?.traceId,
                        customerNumber: destination,
                        previousIsAdminTransaction,
                        currentIsAdminTransaction: newList[numberIndex].isAdminTransaction,
                        apiIsAdminTransaction: previousApiIsAdminTransaction,
                        payloadIsAdminTransaction: data?.isAdminTransaction,
                        payloadIsOpenAdmin: data?.isOpenAdmin,
                        payloadSendType: data?.sendType
                    }, "warn");
                }

                const item = newList[numberIndex];
                newList.splice(numberIndex, 1);
                newList.unshift(item);

                chatTrace("reducer.onChatListener.updated", {
                    traceId: data?.traceId,
                    customerNumber: destination,
                    isOpenTransaction: item.isOpenTransaction,
                    isOpenAdmin: item.isOpenAdmin,
                    isAdminTransaction: item.isAdminTransaction,
                    activityId: item.activityId,
                    activityName: item.activityName
                });
                
                return {
                    ...state,
                    chatList: newList
                }
            }

        case actionTypes.ON_CUSTOMER_SERVICE_LISTENER:
            const newCustomer = action.payload;
            if (!state.chatList.find(c => c.customerNumber === newCustomer.customerNumber)) {
                return {
                    ...state,
                    chatList: [newCustomer, ...state.chatList]
                };
            }
            return state;

        case actionTypes.SELECT_CHAT_FILTER_OPTIONS_SUCCESS:
            return {
                ...state,
                filterOptions: action.payload,
                filterOptionsLoading: false,
                filterOptionsError: false,
                filterOptionsErrorMessage: ""
            };

        case actionTypes.SELECT_CHAT_FILTER_OPTIONS_LOADING:
            return {
                ...state,
                filterOptionsLoading: action.isLoading
            };

        case actionTypes.SELECT_CHAT_FILTER_OPTIONS_ERROR:
            return {
                ...state,
                filterOptionsError: action.hasError,
                filterOptionsErrorMessage: action.errorMessage,
                filterOptionsLoading: false
            };

        case actionTypes.CHANGE_CONVERSATION_ACTIVITY_STATUS_SUCCESS:
            var newList = JSON.parse(JSON.stringify(state.chatList));
            var index = newList.findIndex(w => w.customerNumber == action.customerNumber);

            if (index != -1) {
                newList[index].activityId = action.activityId;
                newList[index].activityName = action.activityName;
            }

            return {
                ...state,
                chatList: newList
            };

        case actionTypes.CHANGE_CONVERSATION_ACTIVITY_STATUS_LOADING:
            return {
                ...state,
                // Could add loading state here if needed for UI feedback
            };

        case actionTypes.CHANGE_CONVERSATION_ACTIVITY_STATUS_ERROR:
            return {
                ...state,
                // Could add error handling here if needed
            };

        case actionTypes.CHANGE_CONVERSATION_MESSAGE_TYPE_SUCCESS:
            var messageTypeList = JSON.parse(JSON.stringify(state.chatList));
            var messageTypeIndex = messageTypeList.findIndex(w => w.customerNumber == action.customerNumber);

            if (messageTypeIndex != -1) {
                messageTypeList[messageTypeIndex].messageType = action.messageType;
            }

            return {
                ...state,
                chatList: messageTypeList
            };

        case actionTypes.CHANGE_CONVERSATION_MESSAGE_TYPE_LOADING:
            return {
                ...state,
                // Could add loading state here if needed for UI feedback
            };

        case actionTypes.CHANGE_CONVERSATION_MESSAGE_TYPE_ERROR:
            return {
                ...state,
                // Could add error handling here if needed
            };

        case actionTypes.START_MANUAL_CHAT_SUCCESS:
            var updatedList = JSON.parse(JSON.stringify(state.chatList));
            var chatIndex = updatedList.findIndex(w => w.customerNumber == action.customerNumber);
            
            if (chatIndex != -1) {
                updatedList[chatIndex].isAdminTransaction = true;
                updatedList[chatIndex].isOpenTransaction = true;
            }
            
            return {
                ...state,
                chatList: updatedList,
            };

        case actionTypes.START_MANUAL_CHAT_LOADING:
            return {
                ...state,
                // Could add loading state here if needed for UI feedback
            };

        case actionTypes.START_MANUAL_CHAT_ERROR:
            return {
                ...state,
                // Could add error handling here if needed
            };

        case actionTypes.UPDATE_CHAT_ITEM_STATUS:
            var newList = JSON.parse(JSON.stringify(state.chatList));
            var index = newList.findIndex(w => w.customerNumber == action.customerNumber);

            if (index != -1) {
                // Sadece undefined olmayan değerleri güncelle (mevcut değerleri koru)
                if (action.isOpenTransaction !== undefined) {
                    newList[index].isOpenTransaction = action.isOpenTransaction;
                }
                if (action.isOpenAdmin !== undefined) {
                    newList[index].isOpenAdmin = action.isOpenAdmin;
                }
                if (action.activityId !== undefined) {
                    newList[index].activityId = action.activityId;
                }
                if (action.activityName !== undefined) {
                    newList[index].activityName = action.activityName;
                }

                chatTrace("reducer.chatStatus.updated", {
                    traceId: action.traceId,
                    customerNumber: action.customerNumber,
                    isOpenTransaction: newList[index].isOpenTransaction,
                    isOpenAdmin: newList[index].isOpenAdmin,
                    activityId: newList[index].activityId,
                    activityName: newList[index].activityName
                });
            } else {
                chatTrace("reducer.chatStatus.missed", {
                    traceId: action.traceId,
                    customerNumber: action.customerNumber,
                    reason: "conversation_not_in_sidebar"
                }, "warn");
            }

            return {
                ...state,
                chatList: newList
            };

        default:
            return state;
    }
}


const chatDetailState = {
    messageList: [],
    isLoading: false,
    hasError: false,
    errorMessage: "",
    customerName: "",
    customerId: "",
    customerImage: "",
    scrollBottomActive: false,
    customerNumber: "",
    isAdminTransaction: false,
    productName:"",
    leadQualification: null,
    activityName:"",
    activityId:0,
    messageType: undefined,
    isOpenTransaction:false,
    isOpenAdmin:false
};

const normalizeDetailCustomerNumber = (value) => {
    if (value === null || value === undefined) {
        return "";
    }

    const text = String(value).trim();
    const digits = text.replace(/\D/g, "");
    return digits || text;
};

export function chatDetailReducer(state = chatDetailState, action) {
    switch (action.type) {
        case actionTypes.SELECT_CHAT_DETAIL_LIST_SUCCESS:
            const incomingProductName = (action.productName || "").trim();
            const keepPreviousProduct = state.customerNumber === action.customerNumber;
            const nextMessageType = action.messageType !== undefined ? action.messageType : (keepPreviousProduct ? state.messageType : undefined);
            const nextMessageTypeName = action.messageTypeName !== undefined ? action.messageTypeName : (keepPreviousProduct ? state.messageTypeName : undefined);


            return {
                ...state,
                messageList: action.payload,
                customerName: action.customerName,
                customerId: action.customerId,
                customerImage: action.customerImage,
                customerNumber: action.customerNumber,
                scrollBottomActive: action.payload.length > 0,
                isAdminTransaction: action.isAdminTransaction !== undefined ? action.isAdminTransaction : state.isAdminTransaction,
                productName: incomingProductName || (keepPreviousProduct ? state.productName : ""),
                // Replace the complete object on every detail response. In
                // particular, null must clear a previous customer's answers.
                leadQualification: action.leadQualification || null,
                activityName:action.activityName,
                activityId:action.activityId,
                messageType: nextMessageType,
                messageTypeName: nextMessageTypeName,
                isOpenTransaction: action.isOpenTransaction !== undefined ? action.isOpenTransaction : state.isOpenTransaction,
                isOpenAdmin: action.isOpenAdmin !== undefined ? action.isOpenAdmin : state.isOpenAdmin,
                isLoading: false,
                hasError: false,
                errorMessage: ""
            };

        case actionTypes.SELECT_CHAT_DETAIL_LIST_LOADING:
            const normalizedLoadingCustomerNumber = normalizeDetailCustomerNumber(action.customerNumber);
            const normalizedCurrentCustomerNumber = normalizeDetailCustomerNumber(state.customerNumber);
            const isDifferentCustomer = Boolean(
                action.isLoading &&
                normalizedLoadingCustomerNumber &&
                normalizedLoadingCustomerNumber !== normalizedCurrentCustomerNumber
            );

            return {
                ...state,
                isLoading: action.isLoading,
                customerNumber: isDifferentCustomer ? action.customerNumber : state.customerNumber,
                productName: isDifferentCustomer ? "" : state.productName,
                leadQualification: isDifferentCustomer ? null : state.leadQualification,
                hasError: action.isLoading ? false : state.hasError,
                errorMessage: action.isLoading ? "" : state.errorMessage,
                scrollBottomActive: false
            };
        case actionTypes.FINISH_ADMIN_CHAT:
            return {
                ...state,
                isAdminTransaction: false,
                isOpenTransaction: false,
                isOpenAdmin: false
            };
        case actionTypes.START_ADMIN_CHAT:
            return {
                ...state,
                isAdminTransaction: true
            };

        case actionTypes.SELECT_CHAT_DETAIL_LIST_ERROR:
            return {
                ...state,
                isLoading: false,
                hasError: action.hasError,
                errorMessage: action.errorMessage,
                scrollBottomActive: false
            };

        case actionTypes.ON_CHAT_LISTENER:

            var data = action.payload;
            var destination = data.customerNumber || data.destination || data.sourcePhone || data.source;
            if (destination == state.customerNumber) {
                var defaultList = JSON.parse(JSON.stringify(state.messageList));
                if (!defaultList.find(msg => msg.mainMessageId === data.mainMessageId)) {
                    defaultList.push(data);
                }

                chatTrace("reducer.chatDetail.messageAppended", {
                    traceId: data?.traceId,
                    customerNumber: destination,
                    messageCount: defaultList.length,
                    mainMessageId: data.mainMessageId
                });

                if (global.chatBodyRef) {
                    setTimeout(() => {
                        global.chatBodyRef.scrollToBottom()
                    }, 250);
                }
                return {
                    ...state,
                    messageList: defaultList,
                    activityId: data.activityId !== undefined ? data.activityId : state.activityId,
                    activityName: data.activityName !== undefined ? data.activityName : state.activityName,
                };

            } else {
                chatTrace("reducer.chatDetail.messageSkipped", {
                    traceId: data?.traceId,
                    customerNumber: destination,
                    activeDetailNumber: state.customerNumber,
                    reason: "different_active_conversation"
                });

                return {
                    ...state,
                }
            }

        case actionTypes.CHANGE_CONVERSATION_ACTIVITY_STATUS_SUCCESS:
            // Chat detail reducer'da da aktivite ID'sini güncelle
            if (state.customerNumber === action.customerNumber) {
                return {
                    ...state,
                    activityId: action.activityId,
                    activityName: action.activityName
                };
            }
            return state;

        case actionTypes.CHANGE_CONVERSATION_MESSAGE_TYPE_SUCCESS:
            if (state.customerNumber === action.customerNumber) {
                return {
                    ...state,
                    messageType: action.messageType
                };
            }
            return state;

        default:
            return state;
    }
}
